<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>

        <span /></template>
    </app-breadcrumb>
    <b-row>
      <b-col md="12">
        <b-card aria-hidden="true">
          <div class="card-header">
            <h4 class="card-title">
              {{ dataModel.name }}
            </h4>
          </div>
          <div class="card-body">
            <div class="table-responsive position-relative table-nowrap">
              <table class="table ">
                <thead>
                  <th>Ngày xuất bản</th>
                  <th>Nội dung</th>
                  <th>Xử lý tin</th>
                  <th>Thể loại</th>
                  <th>Điểm</th>
                  <th>Ghi chú</th>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in dataItems "
                    :key="index"
                  >

                    <td>{{ item.published_at ? formatDateHour(item.published_at) : '' }}</td>
                    <td
                      v-b-tooltip.hover
                      title="Xem chi tiết tin"
                      @click="onPreview(item.article_id)"
                    >{{ item.title }}</td>
                    <td>{{ item.is_author === 1 ? 'Tác giả' : (item.is_author === 2 ? 'Đồng tác giả' : 'Nhờ xử lý') }}</td>
                    <td>{{ item.article_type_name }}</td>
                    <td><input
                      v-model="item.point"
                      class="form-control"
                      type="number"
                    ></td>
                    <td>
                      <input
                        v-model="item.note"
                        class="form-control"
                        type="text"
                      ></td>
                  </tr>

                </tbody>

              </table>
            </div>
            <div class="mx-2 mb-2">
              <b-row v-if="dataItems.length > 0">

                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end mt-1"
                >
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-success mr-1"
                    :disabled="disableBtn"
                    @click="saveApprove"
                  >
                    Duyệt
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger mr-1"
                    :disabled="disableBtn"
                    @click="saveReject"
                  >
                    Từ chối
                  </button>

                </b-col>

              </b-row>
            </div>
          </div>

        </b-card>

      </b-col>
    </b-row>

    <b-modal
      id="showPreview"
      size="lg"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      :title="titleArticle"
    >
      <div v-html="content" />
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback, BTable,
  BFormTags, BTooltip, BInputGroupAppend, BFormTag, BInputGroup, VBTooltip,
} from 'bootstrap-vue'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import moment from 'moment'

function formatPrice(val) {
  const price = val.toString().replace(/,/g, '');
  return price;
}
export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BFormTags,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,
    BFormTag,
    vSelect,
    flatPickr,
    BTable,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,
      titleArticle: '',
      content: '',

    }
  },
  methods: {
    changeManufacture(event) {
      this.itemData.model_id = ''
      store.dispatch('manufacturer/show', { id: event })
        .then(response => {
          if (response.data.code === 200) {
            this.dataModel = response.data.data.models;
          }
        })
    },
    formatDateHour(value) {
      return moment(String(value)).format('DD-MM-YYYY HH:mm:ss');
      // const date = new Date(value * 1000);
      // return `${this.padTo2Digits(date.getDate())}-${this.padTo2Digits(date.getMonth() + 1)}-${date.getFullYear()} ${this.padTo2Digits(date.getHours())}:${this.padTo2Digits(date.getMinutes())}`;
    },
    saveApprove() {
      this.loading = true
      this.disableBtn = true
      store.dispatch('profit/update', { id: this.dataModel.id, dataItems: this.dataItems, status: 30 })
        .then(response => {
          if (response.data.code === 200) {
            this.disableBtn = false
            this.loading = false
            showToast(response.data.message, { variant: 'success' });
            this.$router.push({ name: 'profits-list-approve' })
          } else {
            showToast(response.data.message)
            this.disableBtn = false
            this.loading = false
          }
        })
    },
    saveReject() {
      this.disableBtn = true
      this.loading = true
      store.dispatch('profit/update', { id: this.dataModel.id, dataItems: this.dataItems, status: 40 })
        .then(response => {
          if (response.data.code === 200) {
            this.disableBtn = false
            this.loading = false
            showToast(response.data.message, { variant: 'success' });
            this.$router.push({ name: 'profits-list-approve' })
          } else {
            showToast(response.data.message)
            this.disableBtn = false
            this.loading = false
          }
        })
    },

    onPreview(articleId) {
      this.loading = true
      store.dispatch('profit/showArticle', { id: articleId })
        .then(response => {
          this.loading = false
          if (response.data.code === 200) {
            this.content = response.data.data.content
            this.titleArticle = response.data.data.title
            this.$bvModal.show('showPreview');
          }
        })
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    const devices = ref([])
    const dataCountry = ref([])
    const dataManufacture = ref([])
    const dataItems = ref([])
    const dataProvider = ref([])
    const dataModel = ref([])
    const dataDepartment = ref([])
    const dataUser = ref([])
    const seriesName = ref([])
    const disableBtn = ref(false)
    const localSearchQuery = ref({
      end_date: '',
    });
    const padTo2Digits = (num) => num.toString().padStart(2, '0')

    const defaultItemData = {
      name: '',
      category_type_device_id: null,
      country_id: null,
      manufacture_id: null,
      provider_id: null,
      model_id: null,
      buy_date: '',
      use_begin_date: '',
      warehouse_import_date: '',
      duration_warrantiry: '',
      price_original: '',
      depreciation_rates: '',
      department_id: null,
      manager_id: [],
      series: [],
      note: '',
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    store.dispatch('profit/show', { id: router.currentRoute.params.id })
      .then(response => {
        if (response.status === 200) {
          console.log(response.data.data);
          // userData.value = response.data.data
          loading.value = false
          dataItems.value = response.data.data.rows;
          dataModel.value = response.data.data;
        }
      })
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      errorMessage.value = '';
      loading.value = true;

      const { price_original } = itemData.value;
      itemData.value.price_original = formatPrice(price_original)
      itemData.value.series = seriesName
    }
    const convertCurrency = () => {
      let val = itemData.value.price_original.toString()
      val = val.replace(/,/g, '');

      // eslint-disable-next-line eqeqeq
      if (+val != 0 && !+val) {
        itemData.value.price_original = ''
      } else {
        let subString = val.substring(0, 1);
        if (subString === 0 || subString === '0') {
          subString = val.substring(1);
        } else {
          subString = val;
        }
        const hT = subString.split('.');
        const head = hT[0].split('');
        if (head.length > 3) {
          let index = 3;
          while (head.length - index >= 1) {
            head.splice(head.length - index, 0, ',');
            index += 4;
          }
        }
        itemData.value.price_original = hT.length > 1 ? `${head.join('')}.${hT[1]}` : head.join('');
      }
    }

    const updateSearchQuery = () => {
      console.log(localSearchQuery)
      // fetchCategoryTypeDevice()
    };

    watch(
      () => context.root.$route,
      (to) => {
        if (to.name === 'devices-add') {
          resetItemData();
        } else {
          // fetchData();
        }
      },
    )
    Vietnamese.rangeSeparator = ' - ';
    const configDate = ref({
      dateFormat: 'd/m/Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance onlyf
    });
    const configDateRange = ref({
      dateFormat: 'd/m/Y',
      mode: 'range',
      wrap: true,
      showMonths: 2,
      locale: Vietnamese, // locale for this instance only
    });

    return {
      id,
      layout,
      // errorMessage,
      loading,
      itemData,
      devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      // fetchData,
      dataCountry,
      dataManufacture,
      dataItems,
      dataProvider,
      dataModel,
      dataDepartment,
      dataUser,
      configDate,
      convertCurrency,
      seriesName,
      configDateRange,
      localSearchQuery,
      padTo2Digits,
      updateSearchQuery,
      disableBtn,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
